export { default as HomeWelcome } from './welcome'
export { default as HomeCompany } from './company'
